import { createSlice } from "@reduxjs/toolkit";
import { LoginState } from "../../utils/types/types";

const initialState: LoginState = {
  userId: undefined,
  userName: "",
  isSignedIn: false,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginData: (state, action) => {
      state = action.payload;
      return state;
    },
    signout: (state) => {
      state = { userId: undefined, userName: "", isSignedIn: false };
      return state;
    },
  },
});

export const { loginData, signout } = loginSlice.actions;

export default loginSlice.reducer;
